import React from "react";
import { withRouter } from "react-router";
import NavBar from "../../../components/common/navbar";
import SideBar from "../../../components/modules/left_sidebar";
//import MarcasCommon from "./MarcasCommon";
import Footer from "../../../components/common/Footer";
import FiscalizacaoCommon from "./FiscalizacaoCommon";

const optionMenuArray = {
    linkData: {
        filters: {
            Tabs: {
                Marca: [
                    {
                        key: "Código de Marca",
                        displayKey: "Código de Marca",
                        inputType: "text",
                    },
                    {
                        key: "Nome de Marca",
                        displayKey: "Nome de Marca",
                        inputType: "text",
                    },
                ],
                Entidade: [
                    {
                        key: "Nome de Entidade",
                        displayKey: "Nome de Entidade",
                        inputType: "text",
                    },
                ],
               
            },
            checkbox: [],
        },
        tableName: "FiscPendentes",
        TitleBartitle: "Fiscalização - Pedidos Pendentes",
        prevPageName: "Pendentes",
        prevPageLink: "/fiscalizacao",
        currentPath: "FiscPendentes",
    },
};

class FiscalizacaoPendentes extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...optionMenuArray };
    }
    componentDidMount() {}
    render() {
        return (
            <div className="dashboard">
                <NavBar
                    date={new Date()}
                    linkData={this.state.linkData}
                    noOption={true}
                    moduleName="Fiscalizacao"
                />
                <SideBar Administration={false} />
                <FiscalizacaoCommon
                    linkData={this.state.linkData}
                    tableName={this.state.linkData.tableName}
                />
                <Footer />
            </div>
        );
    }
}

export default withRouter(FiscalizacaoPendentes);
